//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/styles/shadows.js
var e = .2, t = .14, n = .12;
function r(...r) {
	return [
		`${r[0]}px ${r[1]}px ${r[2]}px ${r[3]}px rgba(0,0,0,${e})`,
		`${r[4]}px ${r[5]}px ${r[6]}px ${r[7]}px rgba(0,0,0,${t})`,
		`${r[8]}px ${r[9]}px ${r[10]}px ${r[11]}px rgba(0,0,0,${n})`
	].join(",");
}
var i = [
	"none",
	r(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
	r(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
	r(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
	r(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
	r(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
	r(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
	r(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
	r(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
	r(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
	r(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
	r(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
	r(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
	r(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
	r(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
	r(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
	r(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
	r(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
	r(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
	r(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
	r(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
	r(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
	r(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
	r(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
	r(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
//#endregion
export { i as default };

//# sourceMappingURL=index93.js.map